export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA';
export const GET_LOCAL_DATA = 'GET_LOCAL_DATA';
export const SET_SHIPTO_DATA = 'SET_SHIPTO_DATA';
export const SET_DEFAULTSC_DATA = 'SET_DEFAULTSC_DATA';
export const SET_SC_DATA = 'SET_SC_DATA';
export const SET_CART_DETAILS = 'SET_CART_DETAILS';
export const SET_CART_ORDER_NUMBER = 'SET_CART_ORDER_NUMBER';
export const SET_ORDER_DATA = 'SET_ORDER_DATA';
export const SET_ADMIN_DATA = 'SET_ADMIN_DATA';

export const setUserData = (res) => {
    return (dispatch) => {
        dispatch({
            type: SET_CUSTOMER_DATA,
            payload: res,
        });
    };
};

export const setShipToData = (res) => {
    return (dispatch) => {
        dispatch({
            type: SET_SHIPTO_DATA,
            payload: res,
        });
    };
};

export const setDefaultSCData = (res, func) => {
    return (dispatch) => {
        dispatch({
            type: SET_DEFAULTSC_DATA,
            payload: res,
        });
        func && func();
    };
};

export const setSCData = (res, func) => {
    return (dispatch) => {
        dispatch({
            type: SET_SC_DATA,
            payload: res,
        });

        if (func && typeof func === 'function') {
            func && func();
        }
    };
};

export const setCartDetails = (res) => {
    return (dispatch) => {
        dispatch({
            type: SET_CART_DETAILS,
            payload: res,
        });
    };
};

export const setCartOrderNumber = (res) => {
    return (dispatch) => {
        dispatch({
            type: SET_CART_ORDER_NUMBER,
            payload: res,
        });
    };
};

export const setOrderData = (res) => {
    return (dispatch) => {
        dispatch({
            type: SET_ORDER_DATA,
            payload: res,
        });
    };
};

export const getLocalData = () => {
    return (dispatch) => {
        dispatch({
            type: GET_LOCAL_DATA,
            payload: '',
        });
    };
};

export const setAdminData = (res) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch({
                    type: SET_ADMIN_DATA,
                    payload: res,
                });
                resolve();
            } catch (err) {
                reject(err);
            }
        });
    };
};
